import React from "react";

export default function BlogCard({ title, excerpt, image, author, date, tag }) {
  return (
    <div style={cardStyle}>
      <img src={image} alt={title} style={imageStyle} />

      <div style={{ padding: 16 }}>
        <div style={tagStyle}>{tag}</div>

        <h3 style={titleStyle}>{title}</h3>
        <p style={excerptStyle}>{excerpt}</p>

        <div style={metaStyle}>
          <span>{author}</span>
          <span style={{ opacity: 0.6 }}>•</span>
          <span>{date}</span>
        </div>

        <button style={buttonStyle}>Read More</button>
      </div>
    </div>
  );
}

const cardStyle = {
  width: 320,
  border: "1px solid #eee",
  borderRadius: 12,
  overflow: "hidden",
  boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
  background: "#fff",
};

const imageStyle = {
  width: "100%",
  height: 180,
  objectFit: "cover",
  display: "block",
};

const tagStyle = {
  display: "inline-block",
  fontSize: 12,
  padding: "6px 10px",
  borderRadius: 999,
  background: "#f3f4f6",
  marginBottom: 10,
};

const titleStyle = {
  margin: "6px 0 10px",
  fontSize: 18,
};

const excerptStyle = {
  margin: "0 0 14px",
  opacity: 0.8,
  lineHeight: 1.5,
};

const metaStyle = {
  display: "flex",
  gap: 8,
  fontSize: 12,
  marginBottom: 12,
  opacity: 0.75,
};

const buttonStyle = {
  border: "none",
  padding: "10px 12px",
  borderRadius: 10,
  cursor: "pointer",
  background: "black",
  color: "white",
};